export const SpacerImage = 'https://sigah.blob.core.windows.net/assets/spacer.png'

export const IcoDicasGR1 = 'https://sigah.blob.core.windows.net/assets/DicasGR1.png'

export const IcoPontosFortesGR1 = 'https://sigah.blob.core.windows.net/assets/pontoForteGR1.png'

export const IcoPontosAtencaoGR1 = 'https://sigah.blob.core.windows.net/assets/PontoAtencaoGR1.png'
